__turbopack_context__.v({
  "error-msg": "stepper-module-scss-module__q_tuqa__error-msg",
  "errorIcon": "stepper-module-scss-module__q_tuqa__errorIcon",
  "hint": "stepper-module-scss-module__q_tuqa__hint",
  "label": "stepper-module-scss-module__q_tuqa__label",
  "line": "stepper-module-scss-module__q_tuqa__line",
  "lineBase": "stepper-module-scss-module__q_tuqa__lineBase",
  "lineProgress": "stepper-module-scss-module__q_tuqa__lineProgress",
  "step": "stepper-module-scss-module__q_tuqa__step",
  "step-active": "stepper-module-scss-module__q_tuqa__step-active",
  "step-disabled": "stepper-module-scss-module__q_tuqa__step-disabled",
  "step-error": "stepper-module-scss-module__q_tuqa__step-error",
  "step-error-icon": "stepper-module-scss-module__q_tuqa__step-error-icon",
  "step-non-clickable": "stepper-module-scss-module__q_tuqa__step-non-clickable",
  "step-success": "stepper-module-scss-module__q_tuqa__step-success",
  "step-success-icon": "stepper-module-scss-module__q_tuqa__step-success-icon",
  "stepper": "stepper-module-scss-module__q_tuqa__stepper",
  "steps": "stepper-module-scss-module__q_tuqa__steps",
});
